import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DarkScreenMask, PrimaryButton, Dropdown, KeepAspectRatio } from '../../..';
import { WHITE, ORANGE } from '../../../styles/shared/colors';
import './DownloadVideoModal.scss';

const DownloadVideoModal = ({ isVisible, video, onDecline, onApprove })=> {
  const [ thumbnail, setThumbnail ] = useState(video.thumbnailUri);
  const [ selectedCamera, setSelectedCamera ] = useState(null);
  const SCORE = "SCORE";

  const displayedCameras = [{
    angle: video.angle, 
    vid: video.vid,
    thumbnailUri: video.thumbnailUri 
  }, ...video.moreCameras].filter(camera => {// eslint-disable-line
    
    if(camera && camera.angle) {
     return camera.angle.toLowerCase() !== SCORE.toLocaleLowerCase();
    };

    return camera;
  }) 

  const handleCameraSelect = camera => {
    setSelectedCamera(camera);
    setThumbnail(camera.thumbnailUri);
  };

  const handleSendRequest = ()=> {
    if (selectedCamera) {
      onApprove(selectedCamera.vid);
    } else {
      onApprove(video._id);
    }
  };

  return (
    <DarkScreenMask isVisible={isVisible}>
      <div className="download-video-modal">
        <span>Download video</span>
        {displayedCameras.length > 1 &&
          <Dropdown 
            items={displayedCameras}
            displayedProperty="angle"
            placeholder="Choose Camera"
            onSelect={handleCameraSelect}
          />
        }
        <KeepAspectRatio adjustAcordingToWidth>
          <img className="download-video-modal__image" src={thumbnail} alt=''/>
        </KeepAspectRatio>
        <div>
          <PrimaryButton 
            background={ORANGE} 
            color={WHITE}
            onClick={handleSendRequest}
          >
            Send Request
          </PrimaryButton>
          <PrimaryButton 
            background="transparent" 
            color={WHITE}
            showBorder
            onClick={onDecline} 
          >
            Close
          </PrimaryButton>
        </div>
      </div>
    </DarkScreenMask>
  );
};

DownloadVideoModal.propTypes = {
  isVisible: PropTypes.bool, 
  onApprove: PropTypes.func,
  onDecline: PropTypes.func, 
  video: PropTypes.object 
};

DownloadVideoModal.defaultProps = {
  isVisible: false, 
  onApprove: ()=> {},
  onDecline: ()=> {}, 
  video: {} 
};

export default DownloadVideoModal;